var exports = {
  "az": "Box__B2eZet",
  "wy": "Box_1__uz309Z",
  "pv": "Box_2__18B2ZB",
  "K0": "IconButton__9oMQ5T",
  "w9": "Box_3__XY7oA4",
  "JR": "VerifiedHTMLText__odtQGp",
  "j8": "VerifiedHTMLText_1__fJBGHc",
};

module.exports = exports;
